export default "__VITE_ASSET__01c2d053__"